import $ from 'jquery';
import { getYoutubeVideoId } from './utility';

const Gallery = (container, containerItem) => {
  if (!containerItem || !container) {
    return;
  }

  const classVideoView = 'evolution-gallery-box-video';
  const classGalleryThumbs = 'evolution-gallery-thumbs';

  const createUrlIframe = (videoUrl = null) => {
    if (!videoUrl) {
      return '';
    }

    const videoId = getYoutubeVideoId(videoUrl);
    return `https://www.youtube-nocookie.com/embed/${videoId}?si=tnb&amp;controls=0`;
  };

  const createVideoFrame = (videoUrl = null) => {
    const iframe = document.createElement('iframe');
    iframe.src = createUrlIframe(videoUrl);

    const div = document.createElement('div');
    div.classList.add(classVideoView);
    div.appendChild(iframe);

    const divContainer = document.createElement('div');
    divContainer.classList.add('evolution-gallery-top-view');
    divContainer.appendChild(div);

    return divContainer;
  };

  const createVideoList = (videos = [], images = [], videoUrl = null) => {
    const ul = document.createElement('ul');
    ul.classList.add(classGalleryThumbs);

    videos.forEach((video, index) => {
      const li = document.createElement('li');
      const div = document.createElement('div');
      const span = document.createElement('span');
      div.style.backgroundImage = `url(${images[index]})`;
      div.classList.add('evolution-gallery-box-image');
      if (videoUrl && videoUrl === video) {
        div.classList.add('active');
      }

      div.dataset.video = video;
      div.addEventListener('click', function () {
        const videoUrl = div.getAttribute('data-video');
        const iframe = document.querySelector(`.${classVideoView} iframe`);
        if (iframe) {
          iframe.src = createUrlIframe(videoUrl);

          document
            .querySelectorAll('.evolution-gallery-box-image')
            .forEach((item) => {
              item.classList.remove('active');
            });
          div.classList.add('active');
        }
      });
      div.appendChild(span);
      li.appendChild(div);
      ul.appendChild(li);
    });

    return ul;
  };

  const createDialog = (videoUrl, videoUrlsArray, imageUrlsArray) => {
    const ulElement = createVideoList(videoUrlsArray, imageUrlsArray, videoUrl);
    const iframeElement = createVideoFrame(videoUrl);

    // Content include iframe view and list video
    const dialogContent = document.createElement('div');
    dialogContent.classList.add('evolution-gallery-dialog-content');
    dialogContent.appendChild(iframeElement);
    dialogContent.appendChild(ulElement);

    const dialogWrapper = document.createElement('div');
    dialogWrapper.classList.add('evolution-gallery-dialog-wrapper');
    dialogWrapper.appendChild(dialogContent);

    // handle button close
    const closeElement = document.createElement('span');
    closeElement.classList.add('evolution-gallery-dialog-close');
    closeElement.addEventListener('click', function () {
      const remoteElement = document.querySelector(
        '.evolution-gallery-dialog-wrapper',
      );
      if (remoteElement) {
        remoteElement.remove();
      }
    });

    dialogWrapper.appendChild(closeElement);

    document.body.appendChild(dialogWrapper);
  };

  const collectUrls = (groupId) => {
    const videoUrlsArray = [];
    const imageUrlsArray = [];

    $(`${container} ${containerItem}[data-group="${groupId}"]`).each(
      function () {
        const videoUrl = $(this).data('video');
        const imageUrl = $(this).data('image');
        if (videoUrl && !videoUrlsArray.includes(videoUrl)) {
          videoUrlsArray.push(videoUrl);
        }
        if (imageUrl && !imageUrlsArray.includes(imageUrl)) {
          imageUrlsArray.push(imageUrl);
        }
      },
    );

    return { videoUrlsArray, imageUrlsArray };
  };

  $(document).on('click', containerItem, function () {
    const clickedElement = $(this);
    const videoUrl = clickedElement.data('video');
    const groupId = clickedElement.data('group');

    if (!videoUrl || !groupId) return;

    const { videoUrlsArray, imageUrlsArray } = collectUrls(groupId);
    createDialog(videoUrl, videoUrlsArray, imageUrlsArray);
  });
};

export default Gallery;
